import {
	Dialog,
	NoResults,
	Toolbar
} from "client/Components";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

type NoPermissionsProps = {
	onClose: () => void;
};

export const NoPermissions = (props: NoPermissionsProps): ReactElement => {
	const { onClose } = props;

	return (
		<>
			<Dialog.Header
				hasBorder
				title={localize("_AppStore")}
				onClose={onClose}
			/>
			<Dialog.Body>
				<NoResults
					icon="grid-2"
					title={localize("_NoPermissions")}
					message={localize("_IfYouNeedAccessToTheAppStorePleaseContactYourAdmin")}
					height="fill"
					trackingId="no-permissions"
				/>
			</Dialog.Body>
			<Dialog.Footer hasBorder>
				<Toolbar>
					<Toolbar.Button
						kind="secondary"
						onClick={onClose}
						text={localize("_Close")}
						responsiveBehavior="hide"
						trackingId="close"
					/>
				</Toolbar>
			</Dialog.Footer>
		</>
	);
};

NoPermissions.displayName = "NoPermissions";
